export function getAvailableClientPage(
  totalRows: number,
  requestedPage: number,
  pageSize: number,
) {
  const availablePages = Math.max(1, Math.ceil(totalRows / pageSize));
  return Math.min(Math.max(1, requestedPage), availablePages);
}
